import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { range } from '@/utils/range';

import { RiskCell } from './Cells';
import { ScoresHeatmap } from './ScoresHeatmap';

export const ActivityRisks = ({ category }: { category: 'impacts' | 'dependencies' }) => {
  const { t } = useTranslation();

  const data = useMemo(() => {
    return range(1, 5).map((seed) => {
      return {
        group: `Area ${seed}`,
        ...Object.fromEntries(range(1, 5).map((i) => [`${category} ${i}`, Math.random()])),
      };
    });
  }, [category]);

  return <ScoresHeatmap title={t('shared.disclosure.labels.risks')} data={data} factCell={RiskCell} />;
};
